import styled from "styled-components";
import { motion } from "framer-motion";
import { v, b } from "../../styles/variables";

export const ProjectList = styled(motion.div)`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	gap: ${v.mediumDist};
	position: relative;
`;
